import axios, { AxiosInstance } from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
// import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const instance: AxiosInstance = axios.create();

instance.interceptors.request.use(
  function (config) {
    const loading = document.getElementById('loading-wrapper');
    if (config.method !== 'get') {
      // loading?.classList.remove('bg-L-gray-400/0');
      loading?.classList.add('bg-L-gray-400/80');
      loading?.classList.remove('invisible');
      loading?.classList.remove('opacity-0');
    }

    const client_id = Cookies.get('client_id');
    if (!!client_id && !!config.headers) {
      config.headers.Authorization = `Bearer ${client_id}`;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

const disableLoading = () => {
  const loading = document.getElementById('loading-wrapper');

  let clear = setTimeout(() => {
    loading?.classList.remove('bg-L-gray-400/80');
    loading?.classList.add('opacity-0');
    loading?.classList.add('invisible');

    clearTimeout(clear);
  }, 800);
};

instance.interceptors.response.use(
  (response) => {
    const { t } = i18n;
    const { method } = response.config;
    method !== 'get' && disableLoading();
    try {
      const errors = response.data?.errors[0]
      if (errors) {
        toast.error(t('Errors.' + errors));
      }
      // if (errors === 'OtpIsNotValid') {
      //   toast.error('کد تایید اشتباه است');
      // }
      // // else if (errors === 'TooManyChangePasswordRequest') {
      // // toast.error('تعداد درخواست ها بیش از حد بوده است');
      // // }
      // else if (
      //   errors === 'TooManyChangePasswordRequest' ||
      //   errors === 'OtpTooRequest'
      // ) {
      //   toast.error(
      //     'دفعات استفاده بیش از حد مجاز است. لطفا چند دقیقه دیگر مجدد امتحان کنید'
      //   );
      // } else if (errors === 'SessionExpired') {
      //   toast.error('توکن شما منقصی شده است');
      // } else if (errors === 'UserNotFound') {
      //   toast.error('کدملی یا شماره‌همراه اشتباه است');
      // } else if (errors === 'InvalidCaptcha') {
      //   toast.error('کد امنیتی وارد شده صحیح نمی‌باشد');
      // } else if (errors === 'PasswordIsNotStrongEnough') {
      //   toast.error('رمز عبور فعلی صحیح نمی‌باشد');
      // } else if (errors === 'IncorrectPassword') {
      //   toast.error('رمز عبور فعلی صحیح نمی‌باشد');
      // } else if (errors === 'UserIsLock') {
      //   // toast.error('حساب شما به مدت چند دقیقه غیرفعغال شد.');
      // } else if (errors === 'UserIsNotApproved') {
      //   toast.error('کدملی یا شماره‌همراه اشتباه است');
      // }
    } catch {}
    return response;
  },
  (error) => {
    disableLoading();
    if (error.response) {
      ///write each status code likes 400
      switch (error.response.status) {
        case 400: // Bad Request
          toast.error('خطا در پردازش اطلاعات');
          break;
        case 401: // Unauthorized
          break;
        case 403: // Forbidden
          // toast.error('دسترسی غیرمجاز');
          break;
        case 404: // Not Found
          // handleUnauthorized();
          break;
        case 405: // Method Not Allowed
          toast.error('عدم تطابق اطلاعات');
          break;
        case 408: // Request Timeout
          toast.error('سرعت اینترنت خود را چک کنید');
          break;
        case 429: // Too Many Requests
          if (error.response.data.errors[0] === 'InvalidCaptcha') {
            toast.error('کد امنیتی وارد شده صحیح نمی‌باشد');
            return;
          }
          toast.error('درخواست‌ها بیش از حد مجاز');
          break;
        case 500: // Internal Server Error
          toast.error('خطا در ارتباط با سرور');
          break;
        case 502: // Bad Gateway
          toast.error('پاسخ نامعتبر است');
          break;
        case 503: // Service Unavailable
          // toast.error('سرویس‌ها در دسترسی نمی‌باشند');
          break;
        case 504: // Gateway Timeout
          toast.error('پاسخی دریافت نشد');
          break;
        case 511: // Network Authentication Required
          toast.error('عدم توانایی در احراز هویت برای دسترسی به اینترنت');
          break;
        default:
          toast.error('خطا در پردازش اطلاعات');
          break;
      }
    } else if (error.request) {
      switch (error.message) {
        case 'Network Error':
          break;
        default:
          break;
      }
    } else {
      console.error('Error', error.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
